import { DateTime } from 'luxon';
import { sanitize } from 'dompurify';

export const studlyCase = (str: string) => {
  str = str.replace('_', ' ').replace('-', ' ');
  const r = new RegExp(/(?:^\w|[A-Z]|\b\w|\s+)/g);
  const n = str.replace(r, (x, y) => {
    if (+x === 0) {
      return '';
    }

    const z = y === 0 ? x.toUpperCase() : x.toUpperCase();

    return z;
  });

  return n;
};

/**
 * Uppercase the first character of each word in a string.
 *
 * @example the quick fox => The Quick Fox
 *
 * @param str
 */
export const ucwords = (str: string) => {
  return (str + '').replace(/^(.)|\s+(.)/g, function($1) {
    return $1.toUpperCase();
  });
};

/**
 * Generate a custom avatar using a string (user's name)
 *
 *
 * @param name
 * @param color
 */
export const generateAvatar = (name?: string, color?: string) => {
  return `https://ui-avatars.com/api/?name=${name ? name.replace(' ', '+') : ''}&background=${color ? color: '526880'}&color=fff&font-size=0.4&size=256`;
};

/**
 * Concatenate a string by a amount of characters
 *
 * @param {string} value
 * @param {number} characters defines when the string should be sliced (default 100)
 */
export const concatenate = (value: string, characters = 100): string => {
  if (value.length >= characters) {
    return `${value.slice(0, characters)}...`;
  }
  return value;
};

/**
 * Uppercase the first character of a string.
 *
 * @example the quick fox => The quick fox
 *
 * @param str
 */
export const ucstring = (str: string) => {
  return `${str.charAt(0).toUpperCase()}${str.slice(1)}`
};

export const parseWebsiteUrl = (url: string) => {
  return !url.includes('http://') && !url.includes('https://') ? `https://${url}`: url ;
}

export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve((reader as any).result);
    reader.onerror = (error) => reject(error);
  });
};

export const hex2rgba = (hex: string, opacity: number) => {
  let h: any = hex.replace('#', '');
  h = h.match(new RegExp('(.{' + h.length / 3 + '})', 'g'));

  for (var i = 0; i < h.length; i++) h[i] = parseInt(h[i].length == 1 ? h[i] + h[i] : h[i], 16);

  if (typeof opacity != 'undefined') h.push(opacity);

  return 'rgba(' + h.join(',') + ')';
};

export const avatarHtml = (imageUrl: string) => {
  return `<img class="avatar avatar-small" src="${imageUrl}">`;
};

export const activeHtml = (value: string) => {
  return `<span class="activeItem"><i class="material-icons activeItem">beenhere</i>${value}</span>`;
};

export const iconToHtml = (iconString: string, iconClass?: string, size: number = 16) => {
  return `<i aria-hidden="true" class="icon material-icons ${iconClass}" style="font-size: ${size}px;">${iconString}</i>`
}

export const formatDate = (date: string, luxonFormat: string = 'dd-LL-yyyy') => {
  if (date === '-') {
    return '-';
  }

  if (date === '0000-00-00 00:00:00') {
    return '';
  }

  if (! date) {
    return '';
  }

  return DateTime.fromSQL(date).toFormat(luxonFormat);
};
export const trim = (char: string, str: string) => {
  // Make str regex safe.
  char = char.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');

  return str.replace(`/^[${char}]+|[${char}]+$/g`, '');
};

export const clearWhiteSpace = (str: string) => {
  if (/\s/.test(str)) {
    return str.replace(/\s/g, "");
  }

  return str;
}

export const sortObjectsArrayByProperty = (objects: any[], property: string) => {
  return objects.sort((object1: any, object2: any) => {
    return (object1[property]> object2[property]) ? 1 : ((object2[property] > object1[property]) ? -1 : 0);
  });
}

export const currency = (value: number, currency: string = 'EUR') => {
  return new Intl.NumberFormat('nl-NL', { style: 'currency', currency }).format(value);
}

export const sanitizeString = (value: string, allowHtml: boolean = true) => {
  return sanitize(value, {USE_PROFILES: {html: allowHtml}});
}

export const copyStringToClipboard = (string: string) => {
  let el = document.createElement('textarea');
  el.value = string;
  el.setAttribute('readonly', '');
  (el as any).style = {position: 'absolute', left: '-9999px'};
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
}
